export default {
    SYS_ADMIN_PANEL_FETCH_DATA: "SYS_ADMIN_PANEL_FETCH_DATA",
    SYS_ADMIN_PANEL_UPDATE_INPUT_FIELD: "SYS_ADMIN_PANEL_UPDATE_INPUT_FIELD",
    SYS_ADMIN_ENABLE_MAIN_ACTION: "SYS_ADMIN_ENABLE_MAIN_ACTION",
    
    SYS_ADMIN_TOGGLE_MAIN_ACTION_LOADING: "SYS_ADMIN_TOGGLE_MAIN_ACTION_LOADING",
    SYS_ADMIN_TOGGLE_IS_EXECUTABLE_ACTION_LOADING: "SYS_ADMIN_TOGGLE_IS_EXECUTABLE_ACTION_LOADING",
};